import { useState } from "react";
import { Loader2, PencilLine } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatError } from "@/lib/api";
import { EmailTypoHint } from "@/components/EmailTypoHint";

export const FixContact = ({ mail, onDone }) => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState(mail.recipient_email || "");
  const [phone, setPhone] = useState(mail.recipient_phone || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const left = 2 - (mail.contact_fix_count || 0);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post(`/mail/${mail.id}/fix-contact`, { recipient_email: email, recipient_phone: phone });
      toast.success(data.delivery_problem ? "Details updated, but the notification still couldn't be delivered." : "Details updated and the letter notification resent.");
      setOpen(false);
      onDone();
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="fix-contact-btn" disabled={left <= 0} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-red-600 text-white text-sm font-semibold hover:bg-red-500 transition-colors disabled:opacity-50">
          <PencilLine size={15} /> Fix details & resend</button>
      </DialogTrigger>
      <DialogContent data-testid="fix-contact-dialog">
        <DialogHeader>
          <DialogTitle>Correct contact details</DialogTitle>
          <DialogDescription>We'll send the notification again straight away. The old claim link stops working, and the change is recorded in the letter's history. The recipient's name and address stay the same.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2"><Label htmlFor="fix-email">Recipient email</Label>
            <Input id="fix-email" data-testid="fix-contact-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            <EmailTypoHint email={email} onFix={setEmail} testId="fix-contact-email-typo" /></div>
          <div className="space-y-2"><Label htmlFor="fix-phone">Recipient mobile (optional)</Label>
            <Input id="fix-phone" data-testid="fix-contact-phone-input" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="07700 900123" /></div>
          {error && <p data-testid="fix-contact-error" className="text-sm text-red-600">{error}</p>}
          <div className="flex items-center justify-between gap-3">
            <span className="text-xs text-slate-500" data-testid="fix-contact-remaining">{left} correction{left === 1 ? "" : "s"} left</span>
            <Button data-testid="fix-contact-submit-btn" type="submit" disabled={busy} className="rounded-full">{busy && <Loader2 size={15} className="animate-spin mr-1" />}Save & resend</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
